import { connect } from 'react-redux'

import { showTransientNotification } from '@driftt/traffic-control'
import SettingsPage from 'components/Settings'
import {
  archiveProperty,
  deselectProperty,
  receiveArchivedProperties,
  receiveCustomProperties,
  receiveDriftProperties,
  receiveNewSidebarConfig,
  receiveSalesforceProperties,
  receiveSourcedProperties,
  selectProperty,
  updateProperty,
  updateSourcedProperty 
} from 'modules/settings/actions'

const mapStateToProps = state => ({
  orgId: state.user.orgId,
  selectedProperties: state.__CRM.settings.selectedProperties,
  newConfigProperties: state.__CRM.settings.newConfigProperties,
  customProperties: state.__CRM.settings.customProperties,
  archivedProperties: state.__CRM.settings.archivedProperties,
  driftProperties: state.__CRM.settings.driftProperties,
  sourcedProperties: state.__CRM.settings.sourcedProperties,
  salesforceProperties: state.__CRM.settings.salesforceProperties
})

const mapDispatchToProps = dispatch => {
  return {
    onUpdateProperty: (property, index, location) => {
      dispatch(updateProperty(property, index, location))
    },
    onUpdateSourcedProperty: (property, index) => {
      dispatch(updateSourcedProperty(property, index))
    },
    onSelectProperty: property => {
      dispatch(selectProperty(property))
    },
    onDeselectProperty: property => {
      dispatch(deselectProperty(property))
    },
    onArchiveProperty: property => {
      dispatch(archiveProperty(property))
    },
    onReceiveDriftProperties: properties => {
      dispatch(receiveDriftProperties(properties))
    },
    onReceiveCustomProperties: properties => {
      dispatch(receiveCustomProperties(properties))
    },
    onReceiveArchivedProperties: properties => {
      dispatch(receiveArchivedProperties(properties))
    },
    onReceieveCurrentSidebarSettings: settings => {
      dispatch(selectProperty(settings))
    },
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    },
    onReceiveSourcedAttributes: sourcedProperties => {
      dispatch(receiveSourcedProperties(sourcedProperties))
    },
    onReceiveSalesforceAttributes: properties => {
      dispatch(receiveSalesforceProperties(properties))
    },
    onReceiveNewSidebarConfig: config => {
      dispatch(receiveNewSidebarConfig(config))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPage)
